<template>
    <div class="ui-body">
        <!-- 01.主体容器 - 头部 Start -->
        <div class="ui-container-header">
            <!-- 01.01.主体容器 - 头部 - 标题 Start -->
            <h3 class="ui-container-header-title"><i class="ion-ios-arrow-forward"></i>{{ this.$route.meta.title }}</h3>
            <!-- 01.01.主体容器 - 头部 - 标题 End -->
            <!-- 01.02.主体容器 - 头部 - 副标题 Start -->
            <p class="ui-container-header-subtitle">{{ this.$route.meta.description }}</p>
            <!-- 01.02.主体容器 - 头部 - 副标题 End -->
            <!-- 01.03.主体容器 - 头部 - 按钮组 Start -->
            <div class="ui-container-header-group" v-if="$Permissions(['AdminOperation'])">
                <el-button-group>
                    <el-button @click="operateAllCreate" v-if="$Permissions(['AdminOperationCreate'])"><i class="ion-ios-add-circle"></i>新增</el-button>
                    <el-button @click="operateAllUpload" v-if="$Permissions(['AdminOperationUpload'])"><i class="ion-ios-cloud-upload"></i>导入</el-button>
                    <el-dropdown @command="operateAllDownload" v-if="$Permissions(['AdminOperationDownload'])">
                        <el-button><i class="ion-ios-cloud-download"></i>导出<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="all" v-if="$Permissions(['AdminOperationDownloadAll'])">导出全部</el-dropdown-item>
                            <el-dropdown-item command="part" v-if="$Permissions(['AdminOperationDownloadSelected'])">导出所选</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown @command="operateAllState" v-if="$Permissions(['AdminOperationState'])">
                        <el-button><i class="ion-ios-switch"></i>审核<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="adopt" v-if="$Permissions(['AdminOperationStateOn'])">批量审核</el-dropdown-item>
                            <el-dropdown-item command="failed" v-if="$Permissions(['AdminOperationStateOff'])">批量反审</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button @click="operateAllDelete" v-if="$Permissions(['AdminOperationDelete'])"><i class="ion-ios-close-circle"></i>删除</el-button>
                    <el-button @click="operateAllRefresh" v-if="$Permissions(['AdminOperationRefresh'])"><i class="ion-ios-refresh-circle"></i>刷新</el-button>
                </el-button-group>
            </div>
            <!-- 01.03.主体容器 - 头部 - 按钮组 End -->
        </div>
        <!-- 01.主体容器 - 头部 End -->

        <!-- 02.主体容器 - 内容 Start -->
        <div class="ui-container-content">
            <div class="ui-content">
                <!-- 02.01.主体容器 - 内容 - 搜索 Start -->
                <div class="ui-container-search">
                    <div class="ui-search-quick" v-if="$Permissions(['AdminSearch'])">
                        <!-- 02.01.01.快捷搜索 Start -->
                        <div class="ui-search-quick-input" v-if="$Permissions(['AdminSearchQuick'])">
                            <el-input placeholder="请输入管理员姓名 / 用户名 ..." v-model="quickSearch" class="input-with-select">
                                <el-button type="primary" slot="append" icon="el-icon-search" @click="clickQuickSearch"></el-button>
                            </el-input>
                        </div>
                        <!-- 02.01.01.快捷搜索 End -->
                        <!-- 02.01.02.更多搜索切换 Start -->
                        <div class="ui-search-quick-button" v-if="$Permissions(['AdminSearchMore'])">
                            <el-button @click="searchState=!searchState">更多查询<i :class="searchState?'el-icon-arrow-up':'el-icon-arrow-down'"></i></el-button>
                        </div>
                        <!-- 02.01.02.更多搜索切换 End -->
                    </div>
                    <!-- 02.01.04.更多搜索表单 Start -->
                    <el-collapse-transition>
                        <div class="ui-search-more" v-show="searchState" v-if="$Permissions(['AdminSearchMore'])">
                            <el-scrollbar>
                                <el-form ref="arraySearch" :model="arraySearch" :label-position="searchPosition">
                                    <el-row :gutter="30">
                                        <el-col :span="8">
                                            <el-form-item label="管理员姓名" prop="title">
                                                <el-input v-model="arraySearch.title" placeholder="请输入管理员姓名"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="用户名" prop="user_name">
                                                <el-input v-model="arraySearch.user_name" placeholder="请输入用户名"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="联系电话" prop="phone">
                                                <el-input v-model="arraySearch.phone" placeholder="请输入联系电话"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="30">
                                        <el-col :span="8">
                                            <el-form-item label="电子邮箱" prop="mail">
                                                <el-input v-model="arraySearch.mail" placeholder="请输入电子邮箱"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="审核状态" prop="state">
                                                <el-select v-model="arraySearch.state" clearable placeholder="请选择审核状态">
                                                    <el-option label="待审" value="0"></el-option>
                                                    <el-option label="通过" value="1"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </el-scrollbar>
                            <div class="ui-search-more-group">
                                <el-button type="primary" icon="ion-ios-search" @click="clickArraySearch">搜索</el-button>
                                <el-button icon="ion-ios-repeat" @click="resetArraySearch">重置</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <!-- 02.01.04.更多搜索表单 End -->
                </div>
                <!-- 02.01.主体容器 - 内容 - 搜索 End -->
                <!-- 02.02.主体容器 - 内容 - 表格 Start -->
                <div class="ui-container-table" v-if="$Permissions(['AdminTable'])">
                    <el-table :data="tableData" height="100%" @selection-change="operateSelection" v-loading="tableLoading">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="title" label="管理员姓名" width="120"></el-table-column>
                        <el-table-column prop="user_name" label="用户名" width="150"></el-table-column>
                        <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
                        <el-table-column prop="mail" label="电子邮件"></el-table-column>
                        <el-table-column prop="last_time" label="上次登录时间" width="200"></el-table-column>
                        <el-table-column prop="count" label="登录次数" width="100"></el-table-column>
                        <el-table-column prop="state" label="审核状态" width="100" v-if="$Permissions(['AdminTableState'])">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.state" :active-value="true" :inactive-value="false" active-text inactive-text @change="operateState($event,scope.row.id)"></el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="280" v-if="$Permissions(['AdminTableOperation'])">
                            <template slot-scope="scope">
                                <el-button-group class="ui-table-button-group">
                                    <el-button size="mini" @click="operateRole(scope.row.id)" v-if="$Permissions(['AdminTableOperationRole'])">角色</el-button>
                                    <el-button size="mini" @click="operateResetPass(scope.row.id)" v-if="$Permissions(['AdminTableOperationReset'])">重置密码</el-button>
                                    <el-button size="mini" @click="operatePatch(scope.row.id)" v-if="$Permissions(['AdminTableOperationPatch'])">编辑</el-button>
                                    <el-button size="mini" @click="operateDelete(scope.row.id)" v-if="$Permissions(['AdminTableOperationDelete'])">删除</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 02.02.主体容器 - 内容 - 表格 End -->
            </div>
        </div>
        <!-- 02.主体容器 - 内容 End -->

        <!-- 03.主体容器 - 尾部 Start -->
        <div class="ui-container-footer ">
            <!-- 03.02.主体容器 - 尾部 - 分页 Start -->
            <div class="ui-container-footer-pagination">
                <el-pagination background :current-page="tablePage" :page-sizes="pageSizes" :page-size="pageSize" :total="tableTotal" layout="sizes, prev, pager, next, jumper, total" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
            </div>
            <!-- 03.02.主体容器 - 尾部 - 分页 End -->
        </div>
        <!-- 03.主体容器 - 尾部 End -->

        <!-- 04.角色清单 Start -->
        <el-drawer title="角色清单" :visible.sync="roleDialog" destroy-on-close v-if="$Permissions(['AdminTableOperationRole'])">
            <div class="ui-tree-large">
                <div class="ui-tree-large-header">
                    <el-input placeholder="请输入搜索内容" v-model="searchValue" clearable @input="searchFilter"></el-input>
                </div>
                <el-scrollbar>
                    <el-checkbox-group v-model="part_tree_data">
                        <div class="ui-tree-role" v-for="(item,index) in tree_data" :key="index">
                            <p class="title">{{item.label}}<span>{{item.code}}</span></p>
                            <p class="content" v-html="item.content"></p>
                            <el-checkbox :label="item.id"></el-checkbox>
                        </div>
                    </el-checkbox-group>
                </el-scrollbar>
                <div class="ui-tree-large-footer">
                    <el-button type="primary" icon="ion-ios-checkmark-circle" @click="roleSubmit">更新角色</el-button>
                </div>
            </div>
        </el-drawer>
        <!-- 04.角色清单 End -->

        <!-- 05.批量导入 Start -->
        <el-dialog class="ui-import" title="批量导入数据" :visible.sync="uploadDialog" width="60%" v-if="$Permissions(['AdminOperationUpload'])">
            <Upload v-if="uploadDialog" a-title="系统管理员信息表模板" a-template="/static/template/管理员模板.xlsx" a-api="/api/upload/admin/"></Upload>
        </el-dialog>
        <!-- 05.批量导入 End -->
    </div>
</template>

<script>
    import Upload from "../common/upload"

    export default {
        name: "data_admin",
        components: {Upload},
        data() {
            return {
                // 01.显示模式 ------------------------------------------------
                // 01.01.TreeID
                treeID: "",
                // 02.数据搜索 ------------------------------------------------
                // 02.01.快捷搜索
                quickSearch:'',
                // 02.02.更多搜索
                arraySearch: {
                    title: '',
                    user_name: '',
                    phone: '',
                    mail: '',
                    content: ''
                },
                // 02.03.Search 显示状态
                searchState: false,
                // 02.04.Search 配置 - 标题位置
                searchPosition: 'top',
                // 03.数据数组 ------------------------------------------------
                // 03.01.数据数组 - 数据集
                tableData: [],
                // 03.02.数据数组 - 加载组件
                tableLoading: true,
                // 03.03.所选数据
                multipleTable: [],
                // 04.分页栏目 ------------------------------------------------
                // 04.01.分页栏目 - 当前页
                tablePage: 1,
                // 04.02.分页栏目 - 数据总量
                tableTotal: 400,
                // 04.03.分页栏目 - 每页数量条数
                pageSizes: [20, 50, 100, 200],
                // 04.04.分页栏目 - 分页条数
                pageSize: 20,
                // 05.数据上传/更新 ------------------------------------------------
                // 05.01.上传窗口状态
                uploadDialog: false,
                // 05.02.角色窗口状态
                roleDialog: false,
                // 06.树状框数据集 ------------------------------------------------
                // 06.01.角色数组
                tree_data: [],
                // 06.02.角色所选数组
                part_tree_data: [],
                // 06.03.树状框搜索框
                searchValue: '',
            }
        },
        // 方法集合
        methods: {
            // 01.批量操作 ------------------------------------------------
            // 01.01.全选数据
            operateSelection(val) {
                this.multipleTable = []
                this.multipleSelection = val
                for (var i = 0; i < this.multipleSelection.length; i++) {
                    this.multipleTable.push(this.multipleSelection[i]['id'])
                }
            },
            // 01.02.新增
            operateAllCreate() {
                this.$router.replace('/manage/admin/add-admin')
            },
            // 01.03.批量导入
            operateAllUpload() {
                this.uploadDialog = true
                this.uploadSteps = 0
            },
            // 01.04.批量导出
            operateAllDownload(command) {
                // 01.04.01.导出全部
                if (command === 'all') {
                    this.$confirm('是否批量导出全部数据？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$api.get("/api/download/admin/").then((response) => {
                            this.$message.success(response.message)
                            window.open(this.$api_url + response.path)
                        })
                    }).catch(() => {

                    })
                }
                // 01.04.02.导出所选
                if (command === 'part') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要导出的数据')
                    } else {
                        this.$confirm('是否批量导出所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get("/api/download/admin-active/", {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response.message)
                                window.open(this.$api_url + response.path)
                            })
                        }).catch(() => {

                        })
                    }
                }
            },
            // 01.05.批量审核
            operateAllState(command) {
                // 01.05.01.批量审核
                if (command === 'adopt') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要审核的数据')
                    } else {
                        this.$confirm('是否批量审核所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get('/api/state/admin-on/', {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response)
                                this.operateAllRefresh()
                            })
                        }).catch(() => {

                        })
                    }
                }
                // 01.05.02.批量反审
                if (command === 'failed') {
                    if (this.multipleTable.length === 0) {
                        this.$message.warning('请选择需要反审的数据')
                    } else {
                        this.$confirm('是否批量反审所选数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$api.get('/api/state/admin-off/', {'id': this.multipleTable}).then((response) => {
                                this.$message.success(response)
                                this.operateAllRefresh()
                            })
                        }).catch(() => {

                        })
                    }
                }
            },
            // 01.06.批量删除
            operateAllDelete() {
                if (this.multipleTable.length === 0) {
                    this.$message.warning('请选择需要删除的数据')
                } else {
                    this.$confirm('是否批量删除所选数据？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$api.get('/api/delete/admin-active/', {'id': this.multipleTable}).then((response) => {
                            this.$message.success(response)
                            this.operateAllRefresh()
                        })
                    }).catch(() => {

                    })
                }
            },
            // 01.07.刷新
            operateAllRefresh() {
                this.getTableJson()
            },
            // 02.表格操作 ------------------------------------------------
            // 02.01.编辑
            operatePatch(value) {
                this.$router.replace('/manage/admin/patch-admin/' + value)
            },
            // 02.02.删除
            operateDelete(value) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.get('/api/delete/admin/', {'id': value}).then((response) => {
                        this.$message.success(response)
                        this.operateAllRefresh()
                    })
                })
            },
            // 02.03.审核
            operateState(event, value) {
                this.$api.get('/api/state/admin/', {'id': value, 'state': event}).then((response) => {
                    this.$message.success(response)
                    this.getTableJson()
                })
            },
            // 02.04.重置密码
            operateResetPass(value) {
                this.$confirm('是否重置该管理密码？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.post("/api/patch/admin-reset-password/", {'id': value}).then((response) => {
                        this.$alert(response.message, "重置密码反馈", {
                            confirmButtonText: '确定'
                        })
                    })
                })
            },
            // 02.05.角色
            operateRole(value) {
                this.treeID = value
                this.getPartRole(value)
                this.roleDialog = true
            },
            // 03.获取数据 ------------------------------------------------
            // 03.01.获取Json数据 ( tablePage 当前页  pageSize 分页条数  quickSearch 快捷搜索  arraySearch 更多搜索 )
            getTableJson() {
                this.arraySearch.quick_search = this.quickSearch
                this.arraySearch.table_page = this.tablePage
                this.arraySearch.page_size = this.pageSize
                this.$api.get('/api/get/admin-array/', this.arraySearch).then((response) => {
                    this.tableData = response.data
                    this.pageSize = response.page_size
                    this.tableTotal = response.table_total
                    this.tablePage = response.table_page
                    this.tableLoading = false
                })
            },
            // 03.02.分页栏目 - 分页数
            changeSize(val) {
                // 01.赋值分页数
                this.pageSize = val
                // 02.获取Json数据
                this.getTableJson()
            },
            // 03.03.分页栏目 - 跳转页
            changeCurrent(val) {
                // 01.赋值跳转页
                this.tablePage = val
                // 02.获取Json数据
                this.getTableJson()
            },
            // 04.搜索/查询操作 ------------------------------------------------
            // 04.01.快捷搜索/查询
            clickQuickSearch() {
                // 01.获取Json数据
                this.getTableJson()
            },
            // 04.02.搜索/查询 - 查询提交
            clickArraySearch() {
                // 01.获取Json数据
                this.getTableJson()
                this.searchState = false
            },
            // 04.03.搜索/查询 - 重置Form表单
            resetArraySearch() {
                this.$refs['arraySearch'].resetFields()
                this.getTableJson()
                this.searchState = false
            },
            // 05.获取角色 ------------------------------------------------
            // 05.01.获取角色数据
            getRole() {
                this.$api.get('/api/get/role-tree/').then((response) => {
                    this.tree_data = response.data
                })
            },
            // 05.02.获取已选角色数据
            getPartRole(value) {
                this.treeID = value
                this.part_tree_data.length = 0
                this.$api.get('/api/get/role-active/', {'id': value}).then((response) => {
                    this.part_tree_data = response.data
                })
            },
            // 05.03.树状框搜索
            searchFilter(value) {
                this.$api.get('/api/get/role-tree/', {"value": value}).then((response) => {
                    this.tree_data = response.data
                })
            },
            // 05.04.更新角色
            roleSubmit() {
                // 05.07.03.修改所属角色权限
                this.$api.post('/api/patch/admin-role/', {
                    'id': this.treeID,
                    'role': this.part_tree_data
                }).then((response) => {
                    this.$message.success(response)
                })
            },
        },
        // 生命周期 - 挂载完成
        mounted() {
            // 01.获取Json数据
            this.getTableJson()
            // 02.获取角色数据
            this.getRole()
        },
    }
</script>
